export const UPDATE_ROUTE = 'UPDATE_ROUTE'
export const PREVIOUS_PAGE = 'PREVIOUS_PAGE'
export const NEXT_PAGE = 'NEXT_PAGE'
export const SET_PAGE = 'SET_PAGE'
